import { combineReducers } from 'redux'
import { fetchBootstrapAsync } from 'shared/store/actions/bootstrap'
import { ViewConfiguration } from 'shared/typings/bootstrap'

import { AnyRootAction, createReducer } from 'typesafe-actions'

const settings = createReducer<ViewConfiguration | null, AnyRootAction>(null).handleAction(
  fetchBootstrapAsync.success,
  (_, action) => {
    return action.payload.viewConfiguration
  }
)

export default combineReducers({
  settings,
})
